<template>
  <v-dialog v-model="dialog" transition="dialog-right-transition" fullscreen :scrim="true">
    <form @submit.prevent="$emit('submit')">
      <div
          class="right-dialog d-flex flex-column"
          :style="{
        width: width + 'px',
        backgroundColor: 'rgb(var(--v-theme-surface))',
        color: 'rgb(var(--v-theme-secondary))',
        borderLeft: '1px solid rgb(var(--v-theme-border))'
      }"
      >

        <!-- Header -->
        <div
            class="dialog-header d-flex justify-space-between align-center px-4"
            :style="{
          borderBottom: '1px solid rgb(var(--v-theme-border))'
        }"
        >
          <h3 class="text-h6 mb-0 d-flex align-center">
            <v-btn
                icon="mdi-arrow-left-bold"
                variant="text"
                @click="closeModal"
            />

            {{ title }}
          </h3>

          <v-btn
              icon="mdi-close"
              variant="text"
              @click="dialog = false"
          />
        </div>

        <!-- Body -->
        <div class="dialog-body pa-4">
          <slot name="modalBody"></slot>
        </div>

        <!-- Footer -->
        <div
            class="dialog-footer pa-4"
            :style="{
          borderTop: '1px solid rgb(var(--v-theme-border))'
        }"
        >
          <slot name="modalFooter"></slot>
        </div>

      </div>
    </form>
  </v-dialog>
</template>

<script>
export default {
  name: 'InsertModal',

  props: {
    title: {
      type: String,
      default: 'Modal Title',
    },

    width: {
      type: [String, Number],
      default: 800,
    },
  },

  data() {
    return {
      dialog: false,
    }
  },

  methods: {
    openModal() {
      this.dialog = true
    },

    closeModal() {
      this.dialog = false
    },
  },
}
</script>

<style scoped>
.right-dialog {
  position: fixed;
  top: 0;
  right: 0;
  max-width: 100%;
  height: 100vh;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.15);
}

/* Header */
.dialog-header {
  height: 70px;
  flex-shrink: 0;
}

/* Body */
.dialog-body {
  flex: 1;
  overflow-y: auto;
}

/* Footer */
.dialog-footer {
  min-height: 70px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
</style>